import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Clock } from "lucide-react";
import Tooltip from "../../../../../components/shared/Tooltip";
import { useScheduleContext } from "../../hooks/context/useScheduleContext";
import { useDateFilters } from "../../../../../components/shared/filters/DateFilters/context/useDateFilters";
import { renderDurationAsFormat } from "../../../../../utils/helpers/date";

function HoursTooltip() {
    const { t } = useTranslation();
    const { mode } = useDateFilters();
    const { events } = useScheduleContext();

    const { duration, published, unpublished } = useMemo(() => {
        const _events = (mode === "month" ? [] : events)?.filter((event: any) => {
            return !["unavailable", "open-shifts"].includes(event?.type);
        });
        const duration = _events?.reduce((total: number, current: any) => {
            total += Number(current.duration);
            return total;
        }, 0);

        const published = _events?.filter((event: any) =>
            event?.status === "approved"
        )?.reduce((total: number, current: any) => {
            total += Number(current.duration);
            return total;
        }, 0);

        const unpublished = _events?.filter((event: any) =>
            event?.status === "pending"
        )?.reduce((total: number, current: any) => {
            total += Number(current.duration);
            return total;
        }, 0);

        return { duration, published, unpublished };
    }, [events, mode]);

    return (
        <Tooltip
            trigger={
                <div className="footer-stat-item tw-cursor-pointer">
                    <span className="tw-flex tw-items-center tw-text-neutral-500 tw-text-sm tw-gap-3">
                        <Clock size={16} /> <span>{t("hours")}</span>
                    </span>
                    <span className="tw-font-bold">{renderDurationAsFormat(duration, "HH:mm")}</span>
                </div>
            }
            contentClassName="bg-white tw-text-neutral-900 tw-shadow scheduler-tooltip tw-min-w-xs"
        >
            <div className="tw-p-3 tw-flex tw-flex-col tw-items-start tw-w-full">
                <div className="tw-flex tw-items-center tw-gap-2 tw-w-full tw-mb-3">
                    <Clock size={20} className="text-nutral-500" />
                    <h2 className="tw-text-lg tw-font-semibold">
                        {["day", "week"].includes(mode) ?
                            t("total-day-mode-hours", { mode: mode === "day" ? t("daily") : t("weekly") })
                            : t("total-hours")}
                    </h2>
                </div>
                <div className="tw-w-full">
                    <div className="tw-flex tw-items-center tw-justify-between tw-w-full tw-border-b tw-px-0 tw-py-3">
                        <h2 className="tw-text-sm">{t("published")}</h2>
                        <p className="tw-text-sm tw-font-semibold">{renderDurationAsFormat(published, "HH:mm")}</p>
                    </div>
                    <div className="tw-flex tw-items-center tw-justify-between tw-w-full tw-px-0 tw-py-3">
                        <h2 className="tw-text-sm">{t("unpublished")}</h2>
                        <p className="tw-text-sm tw-font-semibold">{renderDurationAsFormat(unpublished, "HH:mm")}</p>
                    </div>
                </div>
            </div>
        </Tooltip>
    );
}

export default HoursTooltip;
